import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { claimResponseFakeData, oneClaimFakeData } from '../../assets/commonAssets/fakeData.js';
import { ClaimResponse } from '../model/claim/ClaimResponse.model.js';

@Injectable({
	providedIn: 'root'
})
export class ClaimService {	
	
	constructor(private http: HttpClient) { }

	sendClaim(claimRequest): Observable<ClaimResponse> {
		if (environment.fakeData) {
			return of(claimResponseFakeData)
		}
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json'
			})
		};
		return this.http.post<any>('claim/sendClaim', claimRequest, httpOptions);
	}

	checkClaim(claimRequest): Observable<ClaimResponse> {
		if (environment.fakeData) {
			return of(claimResponseFakeData)
		}
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json'
			})
		};
		return this.http.post<any>('claim/checkClaim', claimRequest, httpOptions);
	}
	
	getClaim(uuid) {
		if (environment.fakeData) {
			return of(oneClaimFakeData)
		}
		
		return this.http.get<any>('claim/getClaim/' + uuid)
	}
}
